<template>
    <div>
        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>


<style>
    @import './assets/fonts/styles.css';
    @import './assets/styles/style.css';
    @import './assets/styles/custom.css';
    @import 'filepond/dist/filepond.min.css';
    @import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

</style>

<script>
    import Vue from 'vue'
    import {dateHour, dateLocal, pen} from './directives/currency'
    import {amount} from './directives/amount'
    import Vuelidate from 'vuelidate'
    import {customValidations} from './directives/customValidations'
    import * as VueGoogleMaps from 'vue2-google-maps'
    import {abilitiesPlugin} from "@casl/vue"
    import ability from './util/abilities'
    import TextareaAutosize from 'vue-textarea-autosize'

    Vue.directive("uppercase", {
        update: function (el) {
            el.value = el.value.toUpperCase()
        }
    });

    Vue.directive('pen', pen);
    Vue.directive('dateHour', dateHour);
    Vue.directive('dateLocal', dateLocal);
    Vue.directive('amount', amount);
    Vue.directive('customValidations', customValidations);
    Vue.use(TextareaAutosize)
    Vue.use(Vuelidate);
    Vue.use(VueGoogleMaps, {
        load: {
            key: process.env.GOOGLE_MAPS_API_KEY,
            libraries: 'places',
            region: 'ES',
            language: 'es',
        },
    });
    Vue.use(abilitiesPlugin, ability);

    const default_layout = "user";

    export default {
        computed: {
            layout() {
                return (this.$route.meta.layout || default_layout) + "-layout";
            }
        },
        created() {

        },
        updated() {

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue